var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIconRebrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 4C15.678 4 8.5 11.178 8.5 20C8.5 28.822 17.788 38.88 24.5 44.636C31.208 38.884 40.5 28.822 40.5 20C40.5 11.178 33.322 4 24.5 4ZM24.5 39.308C20.24 35.314 12.5 26.676 12.5 20C12.5 13.382 17.882 8 24.5 8C31.118 8 36.5 13.382 36.5 20C36.5 26.676 28.76 35.314 24.5 39.308Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 22C25.6046 22 26.5 21.1046 26.5 20C26.5 18.8954 25.6046 18 24.5 18C23.3954 18 22.5 18.8954 22.5 20C22.5 21.1046 23.3954 22 24.5 22ZM24.5 26C27.8137 26 30.5 23.3137 30.5 20C30.5 16.6863 27.8137 14 24.5 14C21.1863 14 18.5 16.6863 18.5 20C18.5 23.3137 21.1863 26 24.5 26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconRebrand);
export default __webpack_public_path__ + "static/media/map-icon-rebrand.7f25470c3ac66fc9977b43c46cd6c355.svg";
export { ForwardRef as ReactComponent };